import {WedMgr} from "/@back@/edit/wed/wedEditor.js";
import {HintAnnot, IHintFamilyModel} from "/@lib@/edit/ot/hints.js";

/**
 * Widget qui affiche en liste plusieurs Hints utilisable en popup
 * actuellement, à voir si bascule possible en bar latérale ou en popp flottante qui réagit selon la sel courante.
 */
export class HintsDetails extends HTMLElement {

	wedMgr: WedMgr


	init(wedMgr: WedMgr) {
		this.wedMgr = wedMgr;
		//this.attachShadow(DOMSH.SHADOWDOM_INIT);
	}

	async showHint(hint: HintAnnot, hintModel: IHintFamilyModel) {
		const n = await hintModel.buildDetails(hint, this.wedMgr.docHolder, this.wedMgr.reg, this);
		if (n) {
			this.append(n);
		}
	}

	hasHints() {return this.textContent != null}

	// clearHints() {
	// 	this.textContent = null;
	// }
}
customElements.define('wed-hintsdetails', HintsDetails);